"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var RatingStarBadge = function RatingStarBadge(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 20 20",
    height: "20",
    width: "20"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 23.25,9.938c0,6.588-4.754,12.214-11.25,13.312C5.504,22.152,0.75,16.526,0.75,9.938V0.75h22.5V9.938z ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 0.75,5.25h22.5 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12.53,8.792l1.249,2.458h2.127c0.321-0.008,0.588,0.246,0.596,0.568c0.004,0.163-0.06,0.319-0.177,0.432 l-1.953,1.922l1.082,2.485c0.125,0.3-0.017,0.645-0.317,0.77c-0.17,0.071-0.363,0.058-0.522-0.034L12,15.919l-2.615,1.47 c-0.281,0.163-0.642,0.067-0.805-0.214c-0.092-0.159-0.105-0.352-0.034-0.522l1.082-2.485l-1.953-1.922 c-0.231-0.224-0.237-0.592-0.013-0.823c0.113-0.117,0.27-0.181,0.432-0.177h2.127l1.249-2.454c0.148-0.293,0.505-0.41,0.798-0.262 C12.381,8.587,12.473,8.679,12.53,8.792z",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
RatingStarBadge.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
RatingStarBadge.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = RatingStarBadge;